module.exports = __webpack_public_path__ + "media/img/payments/payment-illustration-2-12ee5d9f10ee3f9e0565486acfb4e3bf.svg";